import { CommonsApi } from '../../generated/api';
import configuration from './configuration';

export default new CommonsApi(configuration);
